/** @jsxImportSource @emotion/react */
import React from "react";
import { Select, Button, Tag, Typography, Row, Col } from "antd";
import * as Styles from "./styles";

export const ANY_OPTION = { label: "Any", value: "<Any>" };

export interface ArrayInputProps {
  label: string;
  values: string[];
  options: string[];
  onAdd: (value: string) => void;
  onRemove: (index: number) => void;
}

export const ArrayInput: React.FC<ArrayInputProps> = ({
  label,
  values,
  options,
  onAdd,
  onRemove,
}: ArrayInputProps) => {
  const [draftValue, setDraftValue] = React.useState("");
  const valueOptions = [];
  valueOptions.push(...options.map((value) => ({ label: value, value })));

  const handleAdd = () => {
    onAdd(draftValue.trim());
    setDraftValue("");
  };

  const handleValueChange = (value: string) => {
    setDraftValue(value);
  };

  const tagListSection =
    values.length > 0 ? (
      <div css={Styles.tagListStyle}>
        {values.map((val, index) => {
          const handleClose = (e: React.MouseEvent<HTMLElement>) => {
            e.preventDefault();
            onRemove(index);
          };
          return (
            <Tag key={val} closable onClose={handleClose} color="blue">
              {val}
            </Tag>
          );
        })}
      </div>
    ) : null;

  return (
    <div css={Styles.sectionStyle}>
      <Row gutter={8} align="middle">
        <Col span={6}>
          <Typography.Text type="secondary">{label}</Typography.Text>
        </Col>
        <Col span={14}>
          <Select
            css={Styles.fullWidthStyle}
            showSearch
            optionFilterProp="label"
            placeholder="Value"
            value={draftValue || undefined}
            onChange={handleValueChange}
            options={valueOptions}
          />
        </Col>
        <Col span={4}>
          <Button onClick={handleAdd}>ADD</Button>
        </Col>
      </Row>
      {tagListSection}
    </div>
  );
};
